import { useSyncExternalStore } from 'react'

const subscribe = (notify: () => void) => {
  document.addEventListener('visibilitychange', notify)
  return () => document.removeEventListener('visibilitychange', notify)
}
export const pageVisible = () => typeof document === 'undefined' || document.visibilityState !== 'hidden'
/** Disable UI reads only; this never pauses durable background jobs. */
export const usePageVisible = () => useSyncExternalStore(subscribe, pageVisible, () => true)
